import { alias } from '@ember/object/computed';

import { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';

import Model from 'umg-ember-backend/models/variant-model';
import {
  buildValidations,
  disabledWhenVariant,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  headline: validator('presence', true),
  startDate: validator('presence', {
    presence: true,
    disabled: disabledWhenVariant(),
  }),
});

export const settings = {
  copyableOptions: {
    ignoreAttributes: [
      'channelsAdditive',
      'channelsExcluded',
      'channelsExclusive',
      'ownedByChannel',
    ],
  },
  variantProperties: [
    'cmsLanguageId',
    'cmsState',
    'headline',
    'text',
    'variantChannel',
  ],
};

export default class MediaEventModel extends Model.extend(Validations) {
  @attr('string') headline;
  @attr startDate;
  @attr startTime;
  @attr endDate;
  @attr('string') text;

  // Variants
  @belongsTo('channel', { async: true, inverse: null }) variantChannel;

  // CMS fields
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @hasMany('artist', { async: true, inverse: null }) artists;
  @belongsTo('link', { async: true, inverse: null }) linkId;
  @hasMany('media-partner', { async: true, inverse: null }) partners;
  @hasMany('channel', { async: true, inverse: null }) channelsAdditive;
  @hasMany('channel', { async: true, inverse: null }) channelsExcluded;
  @hasMany('channel', { async: true, inverse: null }) channelsExclusive;
  @belongsTo('channel', { async: true, inverse: null }) ownedByChannel;

  // Getter, setter and computed properties
  @alias('headline') displayHeadline;
  @alias('headline') displayLabel;
}
